import { useRef } from 'react';

import { useTranslation } from 'react-i18next';

import { useAppContext } from '../../../../../app/Context';
import { getFilePreSignedURL, uploadFileToS3 } from '../../../../../db/shared';
import { i18nNS } from '../../../../../i18n';
import { splitFileNameAndExtension } from '../../../../../utils/files';

const useImageUpload = () => {
  const { t } = useTranslation([i18nNS.COMMON]);

  const { setError } = useAppContext();
  let controller = useRef<AbortController | null>(null);

  const handleImageUpload = async (file: File): Promise<{ downloadUrl: string } | undefined> => {
    const { name: originalFileName, extension: fileType } = splitFileNameAndExtension(file.name, file.name);

    const { message, uploadUrl, contentType, downloadUrl } = await getFilePreSignedURL({
      originalFileName,
      fileType,
    });

    if (message !== 'success') {
      setError(
        t(
          'some_error_occurred_please_try_again_later_if_the_issue_persists_please_contact_us_at_support_email',
          {
            ns: i18nNS.COMMON,
          }
        )
      );
      return undefined;
    }

    // Create a new AbortController for the current request
    controller.current = new AbortController();

    await uploadFileToS3({ uploadUrl, file, contentType, signal: controller.current.signal });
    return { downloadUrl };
  };

  const handleCancelImageUpload = () => {
    if (!controller.current) return;
    controller.current.abort();
  };

  return { handleImageUpload, handleCancelImageUpload };
};

export default useImageUpload;
